/**
 * @generated SignedSource<<e33b0850f20d78ac500bca95b6a39f05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ComponentsCell_ComponentsInlineEditCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "ComponentsCell_ComponentsInlineEditCell";
};
export type ComponentsCell_ComponentsInlineEditCell$key = {
  readonly " $data"?: ComponentsCell_ComponentsInlineEditCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ComponentsCell_ComponentsInlineEditCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "ComponentsCell_ComponentsInlineEditCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraComponentsField"
};

(node as any).hash = "039baef83cb8ffecbd5b697cd1ab09e0";

export default node;
